const STEPS = [
  {
    n: "01",
    title: "Connect your calendar",
    body: "Connect Google or Microsoft. BunnyCal reads your busy times and never writes without your nod.",
  },
  {
    n: "02",
    title: "Set your weekly rhythm",
    body: "Quiet mornings, soft afternoons, no Fridays. BunnyCal honors the shape of your week.",
  },
  {
    n: "03",
    title: "Share one calm link",
    body: "Guests pick a slot; it's held while they book, then confirmed in seconds.",
  },
];

export function LandingHowItWorks() {
  return (
    <section id="how" style={{ padding: "var(--lp-sec-y) 0", background: "var(--lp-ivory-2)" }}>
      <div className="lp-container">
        <span className="lp-eyebrow" data-reveal>How it works</span>
        <h2 className="lp-h1" data-reveal style={{ marginTop: 12 }}>
          Three simple steps <em>to your first booking.</em>
        </h2>
        <div
          className="stack-md"
          data-reveal-group
          style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 18, marginTop: 38 }}
        >
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="lp-lift"
              data-reveal
              style={{
                background: "var(--lp-cream)",
                border: "1px solid var(--lp-border)",
                borderRadius: "var(--lp-radius-card)",
                padding: 26,
                boxShadow: "var(--lp-shadow-soft)",
              }}
            >
              <span style={{ fontFamily: "var(--lp-mono)", fontSize: 12, color: "var(--lp-plum-300)" }}>
                {s.n}
              </span>
              <h3 style={{ fontSize: 20, fontWeight: 600, margin: "10px 0 0", color: "var(--lp-plum-900)" }}>
                {s.title}
              </h3>
              <p style={{ color: "var(--lp-plum-400)", margin: "10px 0 0", fontSize: 15 }}>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
